import { render } from "./StatisticsInfo.vue?vue&type=template&id=4af745c8"
import script from "./StatisticsInfo.vue?vue&type=script&lang=js"
export * from "./StatisticsInfo.vue?vue&type=script&lang=js"

import "./StatisticsInfo.vue?vue&type=style&index=0&id=4af745c8&lang=css"

import exportComponent from "E:\\Work\\GPTWeb\\licCode\\lic\\webviewer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__